export default __webpack_public_path__ + "static/media/our_story_hero.ee9c5eca.webp";